import React from 'react';

const Contact = () => (
  <div className="bg-white min-h-[60vh] flex flex-col items-center justify-center py-24">
    <h1 className="font-display text-4xl md:text-5xl font-bold text-bharat-navy mb-6">Contact Us</h1>
    <p className="text-lg text-slate-700 mb-4">For any questions or feedback, please email us at:</p>
    <a
      href="mailto:info@bharat-calculator.com"
      className="text-saffron-600 hover:text-saffron-700 text-xl font-semibold border-b-2 border-saffron-200"
    >
      info@bharat-calculator.com
    </a>
  </div>
);

export default Contact;
